<template>
    <div>
        <bread-crumb :items="breadcrumbPath" />
        <div style="max-width:700px;">
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>Add Person</v-toolbar-title>
                <v-spacer />
            </v-toolbar>
            <div>
                <div class="lg-8">
                    <v-card>
                        <v-stepper
                            @change="changeStep()"
                            non-linear
                            vertical
                        >
                            <v-stepper-step
                                :complete="false"
                                :rules="[() => { return newPersonFormState('name') !== 'error'; }]"
                                complete-icon="$vuetify.icons.tick"
                                edit-icon="$vuetify.icons.edit"
                                editable
                                error-icon="$vuetify.icons.error"
                                step="1"
                            >
                                Name
                            </v-stepper-step>

                            <v-stepper-content step="1">
                                <Name ref="nameSection" />
                            </v-stepper-content>

                            <v-divider />

                            <v-stepper-step
                                :complete="false"
                                :rules="[() => { return newPersonFormState('phoneNumber') !== 'error'; }]"
                                complete-icon="$vuetify.icons.tick"
                                edit-icon="$vuetify.icons.edit"
                                editable
                                error-icon="$vuetify.icons.error"
                                step="2"
                            >
                                Phone Number
                            </v-stepper-step>

                            <v-stepper-content step="2">
                                <NewPersonPhoneNumber ref="phoneSection" />
                            </v-stepper-content>


                            <v-divider />

                            <v-stepper-step
                                :complete="false"
                                :rules="[() => { return newPersonFormState('address') !== 'error'; }]"
                                complete-icon="$vuetify.icons.tick"
                                edit-icon="$vuetify.icons.edit"
                                editable
                                error-icon="$vuetify.icons.error"
                                step="3"
                            >
                                Address
                            </v-stepper-step>

                            <v-stepper-content step="3">
                                <Address ref="addressSection" />
                            </v-stepper-content>

                            <v-divider />

                            <v-stepper-step
                                :complete="false"
                                :rules="[() => { return newPersonFormState('employment') !== 'error'; }]"
                                editable
                                step="4"
                            >
                                Employment
                            </v-stepper-step>

                            <v-stepper-content step="4">
                                <NewPersonEmployment ref="employmentSection" />
                            </v-stepper-content>

                            <v-divider />
                            <v-stepper-step
                                :complete="false"
                                :rules="[() => { return newPersonFormState('emergencyContact') !== 'error'; }]"
                                editable
                                step="5"
                            >
                                Emergency Contact
                            </v-stepper-step>

                            <v-stepper-content step="5">
                                <NewPersonEmergencyContact ref="emergencyContactSection" />
                            </v-stepper-content>
                            <v-btn
                                @click="savePerson()"
                                class="justify-content-center mt-8 ml-8 primary text--white"
                            >
                                Save
                            </v-btn>

                            <v-btn
                                @click="cancel()"
                                class="justify-content-center mt-8 ml-8 primary text--white"
                            >
                                Cancel
                            </v-btn>
                        </v-stepper>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb.vue'; // @ is an alias to /src
    import Name from '@/views/ManagePersonnel/AddPerson/Name.vue';
    import Address from '@/views/ManagePersonnel/AddPerson/Address.vue';
    import NewPersonEmergencyContact from '@/views/ManagePersonnel/AddPerson/NewPersonEmergencyContact.vue';
    import NewPersonEmployment from '@/views/ManagePersonnel/AddPerson/NewPersonEmployment.vue';
    import NewPersonPhoneNumber from '@/views/ManagePersonnel/AddPerson/NewPersonPhoneNumber.vue';

    import {email, required} from 'vuelidate/lib/validators'
    import {mapGetters} from "vuex";
    import {SAVE_NEW_PERSON,} from "@/store/person/actions";
    import {CHANGE_NEW_PERSON_STEP, RESET_NEW_PERSON_TO_DEFAULT, SET_NEW_PERSON_FORM_SECTION_STATE} from "@/store/person/mutations";
    import {SET_TOASTER_MESSAGE} from "../../../store/this_app/mutations";


    export default {
        $_veeValidate: {
            validator: 'new'
        },
        validations: {
            email: {required, email} // rules object
        },

        name: "AddPerson",

        components: {
            NewPersonPhoneNumber,
            NewPersonEmergencyContact,
            NewPersonEmployment,
            BreadCrumb,
            Name,
            Address,
        },

        beforeRouteLeave(to, from, next) {
            if (this.savingFormAndPassedValidation === false) {
                if (this.$v.$anyDirty === true) {
                    const answer = window.confirm('Do you really want to leave? you have unsaved changes!');
                    if (answer) {
                        this.$store.commit(RESET_NEW_PERSON_TO_DEFAULT);
                        next()
                    } else {
                        next(false)
                    }
                } else {
                    next()
                }
            } else {
                next()
            }
        },

        data: function () {
            return {
                breadcrumbPath: [
                    // {
                    //     text: 'Personnel',
                    //     to: {name: 'home'}
                    // },
                    {
                        text: 'Manage Personnel',
                        to: {name: 'manage personnel'}
                    },
                    {
                        text: 'Add Person',
                        to: '/manage-personnel/add-person',
                        disabled: true,
                    }],
                loading: true,
                personnelVehicle: [],
                holidayAvailable: [],
                // emergencyContacts: [],
                Employments: [],
                selectedPersonnelId: '',
                personnelId: '',
                chosenPerson: {},
                companyList: [],
                companyId: '',
                jobId: '',
                firstPage: true,
                secondPage: false,
                email: '',
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ],
                valid: false,
                menu2: false,
                completed: true,
                savingFormAndPassedValidation: false,
            }


        },


        computed: {
            // nameSectionErrors() {
            //     console.log(this.$refs);
            //     if (typeof this.$refs !== 'undefined' && typeof this.$refs.nameSection !== 'undefined' && typeof this.$refs.nameSection.errors !== 'undefined') {
            //         const errors = this.$refs.nameSection.errors;
            //         return {
            //             errors
            //         }
            //     }
            //
            // },
            ...mapGetters(
            [
                "livePersonnel",
                "person",
                // "editState",
                "nameSectionComplete",
                "newPersonStep",
                "newPersonNameFormState",
                "newPersonFormState",
                "saveNewPersonSuccessful",
            ]
            ),
        },

        methods: {
            resetForm() {
                this.$store.commit(RESET_NEW_PERSON_TO_DEFAULT);
                this.resetValidation();
            },

            cancel() {
                this.resetForm();
                this.redirectToManagePersonnel();
            },

            changeStep(change) {
                this.$store.commit(CHANGE_NEW_PERSON_STEP, change);
            },

            resetValidation() {

                Promise.all([
                    this.$refs.nameSection.$v.$reset(),
                    this.$refs.phoneSection.$v.$reset(),
                    this.$refs.addressSection.$v.$reset(),
                    this.$refs.employmentSection.$v.$reset(),
                    this.$refs.emergencyContactSection.$v.$reset(),
                ]);

                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'name', state: 'clean'});
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'phone', state: 'clean'});
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'address', state: 'clean'});
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'employment', state: 'clean'});
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'emergencyContact', state: 'clean'});
            },

            async validateAll() {

                const results = Promise.all([
                    this.$refs.nameSection.validate(),
                    this.$refs.phoneSection.validate(),
                    this.$refs.addressSection.validate(),
                    this.$refs.employmentSection.validate(),
                    this.$refs.emergencyContactSection.validate(),
                ]);

                await results;

                let resultsArray = [];

                resultsArray.push(this.newPersonFormState('name'));
                resultsArray.push(this.newPersonFormState('phoneNumber'));
                resultsArray.push(this.newPersonFormState('address'));
                resultsArray.push(this.newPersonFormState('employment'));
                resultsArray.push(this.newPersonFormState('emergencyContact'));

                const areValid = resultsArray.every((result) => {
                    return result == 'complete';
                });

                return areValid;
            },

            redirectToManagePersonnel() {
                this.$router.push({name: 'manage personnel'});
            },
            async savePerson() {
                let areValid = this.validateAll();
                const validationResult = await areValid;
                if (validationResult === true) {
                    let saveAttempt = this.$store.dispatch(SAVE_NEW_PERSON);
                    await saveAttempt;

                    if (this.saveNewPersonSuccessful == true) {
                        this.$store.commit(RESET_NEW_PERSON_TO_DEFAULT);

                        this.savingFormAndPassedValidation = true;
                        this.redirectToManagePersonnel();

                        this.$store.commit(SET_TOASTER_MESSAGE, {state: true, value: 'New person saved'});
                    }
                } else {
                    this.$store.commit(SET_TOASTER_MESSAGE, {state: true, value: 'Form has errors'});
                }
            },
        },
    };
</script>

<style scoped>
    .card-header p {
        font-size: 20px !important;
    }

    table label {
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 4px;
    }

</style>
